import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import moment from "moment";
import { GET_EXPENSE_REPORT } from "../Schema/Report";

const useGetExpenseReport = ({ fromDate, toDate, type }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_EXPENSE_REPORT, {
    variables: {
      fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
      toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
      type: type ?? "",
    },
    onCompleted: ({ getExpenseReport }) => {
      setTableData(getExpenseReport || []);
      setLoading(false);
    },
    onError: ({ message }) => {
      console.log("Error::", message);
    },
  });

  useEffect(() => {
    refetch();
  }, [type, fromDate, toDate]);

  return { tableData, loading };
};

export default useGetExpenseReport;
